import React, { useState } from "react";
import { Modal, Row, Col, Button, Space, Flex, Typography, Form } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { MyInput, MySelect } from "../../Forms";
import { apiCalls } from "../../../shared/Apis";

const { Text, Title } = Typography;
const Addreview = ({ visible, onClose, viewdata, getClientApi }) => {
    const [form] = Form.useForm();
    const [ loading, setLoading ] = useState(false)

    const ClientAddReview = async()=>{
        setLoading(true)
        const data = form.getFieldsValue()
        const raw = {
            rate:data?.rate,
            message:data?.description
        }
        const result = await apiCalls?.ClientPostApi?.ClientAddReview({...raw,projectID: viewdata?.id})
        getClientApi()
        if(result){
            form.resetFields();
            onClose();
        }
        setLoading(false)
    }

    const reviews = [
        {
            id: 1,
            name: '1 Star'
        },
        {
            id: 2,
            name: '2 Stars'
        },
        {
            id: 3,
            name: '3 Stars'
        },
        {
            id: 4,
            name: '4 Stars'
        },
        {
            id: 5,
            name: '5 Stars'
        },
    ];
    return (
        <div>
            <Modal
                title={null}
                className="shadow-c modal-cs"
                open={visible}
                onOk={onClose}
                onCancel={onClose}
                closeIcon={false}
                centered
                footer={
                    <Space style={{ justifyContent: "end" }} className="w-100">
                        <Button
                            onClick={onClose}
                            block
                            type="primary"
                            className="btncancel text-white"
                        >
                            Cancel
                        </Button>
                        <Button
                            block
                            type="primary"
                            className="btnsave text-white"
                            htmlType="submit"
                            onClick={()=>form.submit()}
                            loading={loading}
                        >
                            Add Review
                        </Button>
                    </Space>
                }
            >
                <Flex align="center" justify="space-between" className="header-modal">
                    <Title level={5} className="m-0">Add Reviews</Title>
                    <Button className="bg-transparent border0 p-0 " onClick={onClose}>
                        <CloseOutlined className="text-gray" />
                    </Button>
                </Flex>
                <div className="content-modal pb-2">
                    <Form
                        form={form}
                        layout="vertical"
                        initialValues={true}
                        onFinish={ClientAddReview}
                    >
                        <Row gutter={16} justify={'center'}>
                            <Col span={24}>
                                <MySelect
                                    label='Reviews'
                                    name='rate'
                                    size='large'
                                    message='Please enter skills/services'
                                    options={reviews}
                                />
                            </Col>
                            <Col span={24}>
                                <MyInput
                                    textArea
                                    name="description"
                                    label="Description"
                                    placeholder="Enter Description here"
                                    size='large'
                                    value={form.getFieldValue("reviewdesc") || ''}
                                    Row='10'
                                />
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Modal>
        </div>
    );
};

export { Addreview };
